/* Blessed app identity bridge for the preorder product page. */
(() => {
  const body = document.body;
  if (!body || (!body.classList.contains('template-product') && !/pre.?order/i.test(location.pathname))) return;
  const allowed = ['uid', 'version', 'timezone', 'language', 'platform', 'env'];
  const cookie = document.cookie.match(/(?:^|;\s*)_user_info=([^;]*)/);
  if (!cookie) return;
  let raw = cookie[1];
  try { raw = decodeURIComponent(raw); } catch (_) {}
  const info = {};
  const value = raw.charAt(0) === '?' ? raw.slice(1) : raw;
  value.replace(/(?:^|,|\s+)([^=,\s]+)=([^,]*)/g, (_, key, fieldValue) => {
    if (allowed.includes(key)) info[key] = String(fieldValue).trim().slice(0, 200);
    return '';
  });
  if (!info.uid) return;

  const payload = {
    blessed_uid: info.uid,
    blessed_app_version: info.version || '',
    blessed_timezone: info.timezone || '',
    blessed_language: info.language || '',
    blessed_platform: info.platform || '',
    blessed_env: info.env || '',
    page: location.pathname,
  };
  Object.keys(payload).forEach(key => { if (!payload[key]) delete payload[key]; });
  window.elahBlessedIdentity = Object.freeze({ ...payload });

  function addFields(form) {
    if (!form || form.dataset.blessedIdentityAttached) return;
    Object.entries(payload).filter(([key]) => key !== 'page').forEach(([key, value]) => {
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = `properties[_${key}]`;
      field.value = value;
      form.appendChild(field);
    });
    form.dataset.blessedIdentityAttached = 'true';
  }
  const annotate = () => document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]').forEach(addFields);

  function klaviyo(eventName) {
    try {
      const identity = { $id: `blessed:${info.uid}`, ...payload };
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', identity]);
      if (eventName) window._learnq.push(['track', eventName, payload]);
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.identify === 'function') window.klaviyo.identify(identity);
      if (typeof window.klaviyo.track === 'function' && eventName) window.klaviyo.track(eventName, payload);
      if (Array.isArray(window.klaviyo)) {
        window.klaviyo.push(['identify', identity]);
        if (eventName) window.klaviyo.push(['track', eventName, payload]);
      }
    } catch (_) {}
  }

  let cartRequest;
  function cartAttributes() {
    if (cartRequest) return cartRequest;
    const attributes = {};
    Object.entries(payload).forEach(([key, value]) => { attributes[`_${key}`] = value; });
    cartRequest = fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }), keepalive: true,
    }).catch(() => null);
    return cartRequest;
  }

  annotate();
  new MutationObserver(annotate).observe(document.documentElement, { childList: true, subtree: true });
  klaviyo('Elah Preorder Viewed');
  cartAttributes();
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) return;
    addFields(form); klaviyo('Elah Preorder Started'); cartAttributes();
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest && event.target.closest('button[name="add"], [data-checkout="checkout"]');
    if (!trigger) return;
    addFields(trigger.form || trigger.closest('form')); klaviyo('Elah Preorder Started'); cartAttributes();
  }, true);
})();
